import React, { Component } from 'react'
import '../styles/PlayersPicker.css'
import PlayerIconOn from '../images/Booking/player.png'
import PlayerIconOff from '../images/Booking/player-off.png'

class PlayersPicker extends Component {
  constructor(props) {
    super(props)
    this.state = {
      players: this.props.players
    }
  }

  handleDirectChange = (e) => {
    const numberOfPlayers = e.target.id.split("-").pop()

    if (numberOfPlayers >= this.props.playerMin) {
      this.props.pickPlayers(numberOfPlayers)
    }
  }

  render() {
    const playerArray = []
    for (let i = 0 ; i < this.props.players ; i ++) {
      playerArray.push(1)
    }
    const tmpArray = [];
    for (let i = 0 ; i < this.props.playerMax ; i++) {
      tmpArray.push(1);
    }
    const noPlayerArray = tmpArray.slice(this.props.players)
    return (
      <div className="players-picker">
        {
          playerArray.map((x, i) =>
            <img id={`player-icon-${i + 1}`} onClick={(e) => this.handleDirectChange(e)} key={`player-icon-full-${i}`} src={PlayerIconOn} alt=""/>
          )
        }
        {
          noPlayerArray.map((x, i) =>
            <img id={`player-icon-${i + 1 + playerArray.length}`} onClick={(e) => this.handleDirectChange(e)} key={`player-icon-empty-${i}`} src={PlayerIconOff} alt=""/>
          )
        }
        {
          this.props.players > this.props.playerMin
          ?
            <span onClick={() => this.props.pickPlayers(playerArray.length -1)}className="players-picker-action">-</span>
          : null
        }
        {
          this.props.players < this.props.playerMax
          ?
            <span onClick={() => this.props.pickPlayers(playerArray.length + 1)} className="players-picker-action players-picker-action--add">+</span>
          : null
        }
      </div>
    )
  }
}

export default PlayersPicker



// WEBPACK FOOTER //
// ./src/components/PlayersPicker.js